import { render } from "./ModalBox.vue?vue&type=template&id=3b5418de&scoped=true"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=3b5418de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5418de"]])

export default __exports__